import React, { FC, useMemo, useState } from 'react'

import { isSkuEligibleForTruemed } from '../../../../lib/truemed/config'
import { useTruemedConfig } from '../../../../lib/truemed/hooks/useTruemedConfig'
import { TruemedModal } from '../TruemedModal'
import * as Styled from './styled'

import TruemedIcon from '../../../../img/truemed-green.svg'

export const TruemedWidget: FC<{ sku: string | null | undefined }> = ({ sku }) => {
  const { isLoading, isAvailable } = useTruemedConfig()
  const isEligible = useMemo(() => !!sku && isSkuEligibleForTruemed(sku), [sku])

  const [isOpen, setIsOpen] = useState(false)

  if (isLoading || !isAvailable || !isEligible) {
    return null
  }

  return (
    <>
      <Styled.Widget aria-label="Pay with HSA or FSA">
        <Styled.Text>
          <strong>Pay with HSA/FSA</strong>
        </Styled.Text>
        <Styled.Icon src={TruemedIcon} alt="Truemed" />
        <Styled.Text>Save an average of 30%</Styled.Text>

        <Styled.LearnMoreLink
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-haspopup="dialog"
        >
          Learn More
        </Styled.LearnMoreLink>
      </Styled.Widget>

      {isOpen && <TruemedModal isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  )
}
